define('modules/start/products/automation/status/view',['require','exports','module','env','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseView = require("views/BaseView");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        initialize: function() {
            if(this.productDetails) {
                this.listenTo(this.productDetails, "sync", this.render);
            }
        },
        serialize: function() {
            return {
                productDetails: this.productDetails,
                activeScenes: this.productDetails.get('activeScenes')
            };
        }
    });

    module.exports = Layout;
});

